import React, { useCallback } from 'react';

import Tag from 'components/DesignSystem/Tag';
import { MyStudiesFilterChip } from 'types/Flux/Personalized/myStudiesFilters';

export interface FilterChipProps {
  /** Chip montado por `buildFilterChips`. */
  chip: MyStudiesFilterChip;
  /** Posição do chip na lista: o `FilterSummary` a usa para devolver o foco depois de remover. */
  index: number;
  /** Pede a remoção do chip (o `FilterSummary` repassa a mudança dele ao `setFilters`). */
  onRemove: (chip: MyStudiesFilterChip, index: number) => void;
}

/**
 * Um chip removível do resumo da aba Meus Estudos (#1997, .dc.html:227-229), já como item da
 * lista de chips (`<li>`). É a `Tag` do DS com `removeLabel` (#1985): o "x" depois do rótulo é um
 * `<button>` "Remover filtro <rótulo>", acessível por teclado. A aparência (pílula de 28 px) vem
 * do `index.scss` do `FilterSummary`.
 */
export default function FilterChip({ chip, index, onRemove }: FilterChipProps) {
  const remove = useCallback(() => onRemove(chip, index), [onRemove, chip, index]);

  return (
    <li>
      <Tag
        type="active"
        className="my-studies-filter-chip"
        iconPlacement="trailing"
        removeLabel={`Remover filtro ${chip.label}`}
        onClick={remove}
      >
        {chip.label}
      </Tag>
    </li>
  );
}
